import { useCallback } from "react"
import { useTranslation } from "react-i18next"
import Card from "../../common/components/Card"
import { Container, Row, Col } from "../../common/components/Grid"
import useClientConfig from "../../common/hooks/clientConfigHook"
import LevelDropdown from "../LevelDropdown"
import SiteDropdown from "../SiteDropdown"
import TypeDropdown from "../TypeDropdown"
import { useEpcrEditorEpcr } from "./EpcrContext"
import DateInput from "../../common/components/DateInput"
import TimeInput from "../../common/components/TimeInput"
import TextInput from "../../common/components/TextInput"

export const EpcrQuickSearch = () => {
    const { t } = useTranslation();
    const { epcr, update } = useEpcrEditorEpcr();
    const clientConfig = useClientConfig();

    const handleTypeUpdate = useCallback(v => {
        update('type', v.type);
        if (clientConfig.enableSites && v.site) {
            update('site', v.site);
        }
        if (clientConfig.enableLevels && v.level) {
            update('level', v.level);
        }
    }, [update, clientConfig.enableSites, clientConfig.enableLevels]);

    const handleLevelUpdate = useCallback(v => {
        update('level', v.level);
        if (clientConfig.enableSites && v.site) {
            update('site', v.site);
        }
    }, [update, clientConfig.enableSites]);

    return <Container fluid>
        <Card>
            <Row>
                <Col>
                    <TextInput value={epcr.displayid} placeholder={t('idNumber')} onChange={value => update('displayid', value)}></TextInput>
                </Col>
                { !clientConfig.epcrOnly && <>
                    { clientConfig.enableSites && <Col>
                        <SiteDropdown site={epcr.site} prem="read" wildcard={t('anyWildcard')} onChange={value => update('site', value?.site)}></SiteDropdown>
                    </Col> }
                    { clientConfig.enableLevels && <Col>
                        <LevelDropdown site={epcr.site} level={epcr.level} prem="read" wildcard={t('anyWildcard')} onChange={handleLevelUpdate}></LevelDropdown>
                    </Col> }
                    <Col>
                        <TypeDropdown site={epcr.site} level={epcr.level} type={epcr.type} perm="read" wildcard={t('anyWildcard')} onChange={handleTypeUpdate}></TypeDropdown>
                    </Col>
                </>}
            </Row>
        </Card>
        <Card>
            <Row>
                <Col>
                    <DateInput value={epcr.creationAfter} placeholder={t('createdAfterDate')} onChange={value => update('creationAfter', value)}></DateInput>
                </Col>
                <Col>
                    <TimeInput value={epcr.creationAfter} placeholder={t('createdAfterTime')} onChange={value => update('creationAfter', value)}></TimeInput>
                </Col>
                <Col>
                    <DateInput value={epcr.creationBefore} placeholder={t('createdBeforeDate')} onChange={value => update('creationBefore', value)}></DateInput>
                </Col>
                <Col>
                    <TimeInput value={epcr.creationBefore} placeholder={t('createdBeforeTime')} onChange={value => update('creationBefore', value)}></TimeInput>
                </Col>
            </Row>
        </Card>
        <Card>
            <Row>
                <Col>
                    <DateInput value={epcr.finalizedAfter} placeholder={t('finalizedAfterDate')} onChange={value => update('finalizedAfter', value)}></DateInput>
                </Col>
                <Col>
                    <TimeInput value={epcr.finalizedAfter} placeholder={t('finalizedAfterTime')} onChange={value => update('finalizedAfter', value)}></TimeInput>
                </Col>
                <Col>
                    <DateInput value={epcr.finalizedBefore} placeholder={t('finalizedBeforeDate')} onChange={value => update('finalizedBefore', value)}></DateInput>
                </Col>
                <Col>
                    <TimeInput value={epcr.finalizedBefore} placeholder={t('finalizedBeforeTime')} onChange={value => update('finalizedBefore', value)}></TimeInput>
                </Col>
            </Row>
        </Card>
    </Container> 
}